// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1ddw3";
export { _1 as "__esModule", _2 as "root" }
export default { "__esModule": _1, "root": _2 }
